// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'

// Add the Firebase products that you want to use
import 'firebase/firestore';
import 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyAFIm2cbWa5lHhO4vQbo3j2KktwG2kQ2i8",
    authDomain: "adoptzi.firebaseapp.com",
    projectId: "adoptzi",
    storageBucket: "adoptzi.appspot.com",
    messagingSenderId: "553451901594",
    appId: "1:553451901594:web:61140b769001dbfd930523",
    measurementId: "G-FDJN4282CH"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const analytics = firebase.analytics();